module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-flex', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "offset-md1": "",
      "md10": ""
    }
  }, [_c('h1', [_vm._v("Pagina em construção")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ec8f424","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/orcamentos/index.vue
// module id = 764
// module chunks = 38